import React from 'react';
import './browse_shipment_detail.less';
import moment from 'moment';
import {Link, browserHistory} from 'react-router';

class ShipmentDetails extends React.Component{
  constructor(props){
    super(props);
  }
  render(){
    const {props} = this;
    let shipment = props.shipment;
    const sizeArray = ['Small', 'Medium', 'Large', 'Extra Large']
    const monthArray = ['Jan', 'Feb', "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    let deliveryTimestamp = shipment.deliveryDate;
    let deliveryDay = moment(deliveryTimestamp).format('D');
    let deliveryMonth = moment(deliveryTimestamp).format('M');
    let itemRequest;
    let shipmentDistance;
    let shipmentSize = sizeArray[shipment.itemSize-1];
    let defaultImgUrl = "../../public/images/requester_flow/placeholder.png";
    if(!shipment.thumbnailImage || shipment.thumbnailImage =="")
      shipment.thumbnailImage = defaultImgUrl;
    (shipment && shipment.distance && shipment.distance != 0 ) ? (shipmentDistance = Math.round(shipment.distance)) : (shipmentDistance = null);
    (shipment.shipmentType == 2) ? (itemRequest = true) : (itemRequest = false);

    const link = "/shipment/" + shipment.shipmentId + '?backTo=' + 'browse';
    return(
      <Link to = {link}>
        <div className="shipment-details-wrap">
          <div className="shipment-image-wrap">
           {shipment.thumbnailImage && <div style = {{"backgroundImage": 'url("' + shipment.thumbnailImage + '")'}} className="shipment-image"></div>}
          </div>
          <div className="shipment-details">
            { itemRequest && <div className="item-request"><div className="item-request-img"></div><span className="item-request-text">Item Request</span></div>}
            <div className="shipment-title">{shipment.title}</div>
            <div className="shipment-delivery-location"><span className="shipment-delivery-to">To:&nbsp;</span>{shipment.deliveryLocation},&nbsp;{shipment.deliveryCountry}</div>
            <div className="shipment-size">
              {shipmentSize && <span>{shipmentSize}&nbsp;|&nbsp;</span>}
              <span>${shipment.itemValue}&nbsp;value</span>
            </div>
            <div className="shipment-delivery"><span className="deliver-by">Deliver by</span> {monthArray[deliveryMonth - 1]}&nbsp;{deliveryDay}</div>
          </div>
          <div className="shipment-cost-wrap">
            <div className="shipment-cost">${shipment.shipmentCost}</div>
            {shipmentDistance && <div className="shipment-distance">{shipmentDistance}&nbsp;mi</div>}
          </div>
        </div>
    </Link>
    )
  }
}

export default ShipmentDetails;



// WEBPACK FOOTER //
// app/browse_packages/browse_shipment_detail.jsx